import { render } from "./ProductStoreActionsPopover.vue?vue&type=template&id=7a0b8088&ts=true"
import script from "./ProductStoreActionsPopover.vue?vue&type=script&lang=ts"
export * from "./ProductStoreActionsPopover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__